import { Outlet } from "react-router-dom";
import { adminStationsRoutes } from "./Stations/stations-routes";
import { adminBaggageTripsRoutes } from "./BaggageTrips/baggage-trips-routes";
import { adminBaggageTariffsRoutes } from "./BaggageTariffs/baggage-tariffs-routes";
import { adminBaggageRoutes } from "./Baggage/baggage-routes";
import { adminBaggageScanRoutes } from "./BaggageScan/baggage-scan-routes";
import { adminBaggageArrivalsRoutes } from "./Arrivals/arrivals-routes";
import { adminBaggageStatsRoutes } from "./Stats/stats-routes";
import { adminCounterpartiesRoutes } from "./Counterparties/counterparties-routes";
import { adminWagonsRoutes } from "./Wagons/wagons-routes";
import { adminRunsRoutes } from "./Runs/runs-routes";

export const adminBaggagesRoutes = [
  {
    path: "baggages",
    element: Outlet,
    children: [
      {
        path: "",
        redirect: 'baggage-trips'
      },
      ...adminBaggageRoutes,
      ...adminBaggageArrivalsRoutes,
      ...adminStationsRoutes,
      ...adminWagonsRoutes,
      ...adminRunsRoutes,
      ...adminCounterpartiesRoutes,
      ...adminBaggageTripsRoutes,
      ...adminBaggageScanRoutes,
      ...adminBaggageTariffsRoutes,
      ...adminBaggageStatsRoutes,
    ],
  },
];
